import React, { useState, useEffect, useRef, useCallback } from "react";
import { Line } from "react-chartjs-2";
import { DatePicker, Input } from "antd";
import dayjs from "dayjs";
import { message } from "antd";
import ReactTable from "react-table";
import {
  // withFixedColumnsScrollEvent,
  withFixedColumnsStickyPosition,
} from "react-table-hoc-fixed-columns";
import {
  onFetchSigninLogs,
  onFetchLogStatistic,
  onFetchSigninLogsSearch,
  onFetchLogStatisticUpdate,
} from "../../Api/AppBackend/DashboardStatistic";
import Pagination from "../../Components/CustomTable/Pagination";
import PageTitle from "../../Layout/AppMain/PageTitle";
import Loader from "react-loaders";
import { useHistory } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";

const ReactTableFixedColumns = withFixedColumnsStickyPosition(ReactTable);

const Dashboard = (props, typeUser) => {
  const [timePeriod, setTimePeriod] = useState("hour");
  const [timePeriodUpdate, setTimePeriodUpdate] = useState("hour");
  const [fromDate, setFromDate] = useState(
    dayjs().startOf("day").format("YYYY-MM-DD HH:mm")
  );
  const [toDate, setToDate] = useState(
    dayjs().endOf("day").format("YYYY-MM-DD HH:mm")
  );
  const [fromDateUpdate, setFromDateUpdate] = useState(
    dayjs().startOf("day").format("YYYY-MM-DD HH:mm")
  );
  const [toDateUpdate, setToDateUpdate] = useState(
    dayjs().endOf("day").format("YYYY-MM-DD HH:mm")
  );
  const dateFormatList = [
    "DD/MM/YYYY HH:mm",
    "DD/MM/YY HH:mm",
    "DD-MM-YYYY HH:mm",
    "DD-MM-YY HH:mm",
  ];
  const [userData, setUserData] = useState([]);
  const [curObj, setCurObj] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(30);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSizeOptions, setPageSizeOptions] = useState([
    30, 50, 100, 200, 300, 500, 1000
  ]);
  const { RangePicker } = DatePicker;
  const [searchTerm, setSearchTerm] = useState("");
  const [isSelectingRange, setIsSelectingRange] = useState(false);
  const searchInputRef = useRef(null);
  const history = useHistory();

  //Set state cho chart data
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: props.t("Number of Login Accounts"),
        data: [],
        fill: false,
        borderColor: "rgba(75, 192, 192, 1)",
        tension: 0.1,
        pointBackgroundColor: "rgba(75, 192, 192, 1)",
      },
    ],
  });
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState([]);

  // Hàm get dữ liệu đăng nhập
  const fetchSigninLogs = async () => {
    if (!isSelectingRange && fromDate && toDate) {
      try {
        const res = await onFetchSigninLogs(
          fromDate, 
          toDate,
          pageIndex,
          pageSize
        );
        if (res.data.isSuccess) {
          const formattedData = res.data.data.map((record) => ({
            userWebId: record.userWebId,
            userName: record.userName,
            fullName: record.fullName,
            address: record.address,
            sex: record.sex,
            phone: record.phone,
            inTime: dayjs(record.inTime).format("DD/MM/YYYY HH:mm:ss"),
          }));
          setUserData(formattedData);
          setTotalRecords(res.data.totalRecords);

          //Lọc dữ liệu
          const filtersResult = filterDataManual(formattedData, filters);
          setData(filtersResult);
        } else {
          // message.error(res.data.err.msgString);
        }
      } catch (err) {
        message.error(err);
      } 
    }
  };

  // Hàm get dữ liệu đăng nhập khi chọn thời gian
  const fetchUpdateSigninLogs = async () => {
    if (
      isSelectingRange &&
      dayjs.isDayjs(fromDateUpdate) &&
      dayjs.isDayjs(toDateUpdate)
    ) {
      try {
        const formattedFromDate = fromDateUpdate.format(
          "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
        );
        const formattedToDate = toDateUpdate.format(
          "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
        );
        const res = await onFetchSigninLogs(
          formattedFromDate,
          formattedToDate,
          pageIndex,
          pageSize
        );
        if (res.data.isSuccess) {
          const formattedData = res.data.data.map((record) => ({
            userWebId: record.userWebId,
            userName: record.userName,
            fullName: record.fullName,
            address: record.address,
            sex: record.sex,
            phone: record.phone,
            inTime: dayjs(record.inTime).format("DD/MM/YYYY HH:mm:ss"),
          }));
          setUserData(formattedData);
          setTotalRecords(res.data.totalRecords);

          //Lọc dữ liệu
          const filtersResult = filterDataManual(formattedData, filters);
          setData(filtersResult);
        } else {
          // console.error("Error:", response.data.err.msgString);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    }
  };

  //Hàm tìm kiếm thống kê lượng đăng nhập
  const onFetchSigninLogSearch = useCallback(async (searchTerm) => {
    if (fromDate && toDate) {
      try {
        const res = await onFetchSigninLogsSearch(fromDate, toDate, searchTerm);
        if (res.data.isSuccess) {
          const formattedData = res.data.data.map((record) => ({
            userWebId: record.userWebId,
            userName: record.userName,
            fullName: record.fullName,
            address: record.address,
            sex: record.sex,
            phone: record.phone,
            inTime: dayjs(record.inTime).format("DD/MM/YYYY HH:mm:ss"),
          }));
          setUserData(formattedData);
          setTotalRecords(res.data.totalRecords);
        } else {
          // message.error(res.data.err.msgString);
        }
      } catch (err) {
        message.error(err);
      }
    }
  });

  //Hàm tìm kiếm thống kê lượng đăng nhập khi chọn thời gian
  const onFetchUpdateSigninLogSearch = useCallback(async (searchTerm) => {
    if (dayjs.isDayjs(fromDateUpdate) && dayjs.isDayjs(toDateUpdate)) {
      try {
        const formattedFromDate = fromDateUpdate.format(
          "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
        );
        const formattedToDate = toDateUpdate.format(
          "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
        );
        const res = await onFetchSigninLogsSearch(
          formattedFromDate,
          formattedToDate,
          searchTerm
        );
        if (res.data.isSuccess) {
          const formattedData = res.data.data.map((record) => ({
            userWebId: record.userWebId,
            userName: record.userName,
            fullName: record.fullName,
            address: record.address,
            sex: record.sex,
            phone: record.phone,
            inTime: dayjs(record.inTime).format("DD/MM/YYYY HH:mm:ss"),
          }));
          setUserData(formattedData);
          setTotalRecords(res.data.totalRecords);
        } else {
          // message.error(res.data.err.msgString);
        }
      } catch (err) {
        message.error(err);
      }
    }
  });

  //Hàm get data
  const fetchSigninLogsStat = useCallback(async () => {
    try {
      let statisticType;
      switch (timePeriod) {
        case "hour":
          statisticType = 1;
          break;
        case "day":
          statisticType = 2;
          break;
        case "month":
          statisticType = 3;
          break;
        default:
          statisticType = 1;
      }

      const response = await onFetchLogStatistic(
        fromDate,
        toDate,
        statisticType
      );

      if (response.data.isSuccess) {
        const loginRecords = response.data.data.map((item) => item.value);
        const labels = response.data.data.map((item) => item.key);
        setChartData({
          labels: labels,
          datasets: [
            {
              label: props.t("Number of Login Accounts"),
              data: loginRecords,
              fill: false,
              borderColor: "rgba(75, 192, 192, 1)",
              tension: 0.1,
              pointBackgroundColor: "rgba(75, 192, 192, 1)",
            },
          ],
        });

        return { loginRecords, labels };
      } else {
        console.error(
          "Expected an array but received:",
          typeof response.data.data
        );
        return { loginRecords: [], labels: [] };
      }
    } catch (error) {
      console.error("Error fetching signin logs:", error);
      return { loginRecords: [], labels: [] };
    }
  });

  //Hàm get data khi chọn thời gian
  const fetchSigninLogsStatUpdate = useCallback(async () => {
    if (dayjs.isDayjs(fromDateUpdate) && dayjs.isDayjs(toDateUpdate)) {
      try {
        const formattedFromDate = fromDateUpdate.format(
          "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
        );
        const formattedToDate = toDateUpdate.format(
          "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
        );
        let statisticType;
        switch (timePeriodUpdate) {
          case "hour":
            statisticType = 1;
            break;
          case "day":
            statisticType = 2;
            break;
          case "month":
            statisticType = 3;
            break;
          default:
            statisticType = 1;
        }
        const response = await onFetchLogStatisticUpdate(
          formattedFromDate,
          formattedToDate,
          statisticType
        );
        if (response.data.isSuccess) {
          const loginRecords = response.data.data.map((item) => item.value);
          const labels = response.data.data.map((item) => item.key);
          setChartData({
            labels: labels,
            datasets: [
              {
                label: props.t("Number of Login Accounts"),
                data: loginRecords,
                fill: false,
                borderColor: "rgba(75, 192, 192, 1)",
                tension: 0.1,
                pointBackgroundColor: "rgba(75, 192, 192, 1)",
              },
            ],
          });
          return { loginRecords, labels };
        } else {
          console.error(
            "Expected an array but received:",
            typeof response.data.data
          );
          return { loginRecords: [], labels: [] };
        }
      } catch (error) {
        console.error("Error fetching signin logs:", error);
        return { loginRecords: [], labels: [] };
      }
    }
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text:
            timePeriod === "hour"
              ? "Giờ"
              : timePeriod === "month"
              ? "Tháng"
              : "Ngày",
        },
      },
      y: {
        title: {
          display: true,
          text: props.t("Number of Logins"),
        },
        beginAtZero: true,
      },
    },
  };

  const onHandleSearchChange = () => {
    const searchTerm = searchInputRef.current?.input?.value || "";
    if (searchTerm !== "") {
      if (!isSelectingRange) {
        onFetchSigninLogSearch(searchTerm);
      } else {
        onFetchUpdateSigninLogSearch(searchTerm);
      }
    } else {
      if (!isSelectingRange) {
        onFetchSigninLogSearch();
      } else {
        onFetchUpdateSigninLogSearch();
      }
    }
  };

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  //Hàm xử lý lọc dữ liệu thủ công
  const onHandleFilterChange = (newFilters) => {
    setFilters(newFilters); //Lưu trạng thái filter mới
    const filterResult = filterDataManual(userData, newFilters); //Gọi hàm lọc
    setData(filterResult); //Cập nhật trạng thái dữ liệu lọc
  };

  const filterDataManual = (data, filters) => {
    //Kiểm tra nếu ko filters thì trả ra toàn bộ data
    if (!filters || filters.length === 0) return data;

    return data.filter((row) => {
      return filters.every((filter) => {
        const { id, value } = filter;
        if (!value) return true; //Kiểm tra nếu ko có giá trị lọc thì return true tức là bỏ qua
        const cellValue = row[id] ? String(row[id]).toUpperCase() : ""; //Giá trị cột hiện tại
        return cellValue.includes(String(value).toUpperCase());
      });
    });
  };

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const [newFromDate, newToDate] = dates;
      if (newFromDate.isBefore(newToDate) || newFromDate.isSame(newToDate)) {
        setFromDateUpdate(newFromDate);
        setToDateUpdate(newToDate);
        setIsSelectingRange(true);
      } else {
        setIsSelectingRange(false);
      }
    } else {
      setIsSelectingRange(false);
    }
  };

  const onHandleTimePeriodChange = (period) => {
    if (!isSelectingRange) {
      setTimePeriod(period);
    } else {
      setTimePeriodUpdate(period);
    }
  };

  useEffect(() => {
    const typeUser = Number(localStorage.getItem("typeUser"));
    if (typeUser !== 1) {
      message.error(props.t("You do not have permission to access this page"));
      history.push("/");
    }
  }, [history]);

  useEffect(() => {
    if (isSelectingRange) {
      fetchUpdateSigninLogs();
    }
  }, [pageIndex, pageSize, isSelectingRange, fromDateUpdate, toDateUpdate]);

  useEffect(() => {
    if (!isSelectingRange) {
      fetchSigninLogs();
    }
  }, [pageIndex, pageSize, fromDate, toDate]);

  // useEffect(() => {
  //   fetchSigninLogs();
  // }, [pageIndex, pageSize, fromDate, toDate]);

  // useEffect(() => {
  //   fetchUpdateSigninLogs();
  // }, [pageIndex, pageSize, toDateUpdate, fromDateUpdate]);

  useEffect(() => {
    fetchSigninLogsStat();
  }, [timePeriod, fromDate, toDate]);

  useEffect(() => {
    fetchSigninLogsStatUpdate();
  }, [timePeriodUpdate, toDateUpdate, fromDateUpdate]);

  //Hàm bắt sự kiện khi double click vào 1 row sẽ hiện lên Edit modal
  const getTrProps = (state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      return {
        onClick: (e) => {
          if (e.detail === 2) {
            setEditModal(true);
            setCurObj(rowInfo.row);
          }
        },
      };
    } else {
      return {};
    }
  };

  return (
    loading ? (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "200px", width: "100%" }}
      >
        <Loader type="ball-pulse-rise" color="#007bff" />
      </div>
    ):(
      <div className="dashboard">
      <div className="header-content-static">
        <div className="tittle-container">
          <div className="tittle-name">{props.t("DASHBOARD SUMMARIZE")}</div>
          <div className="datetime-picker-item">
            <RangePicker
              format={dateFormatList}
              size="large"
              showTime={{ format: "HH:mm" }}
              allowClear={false}
              value={[dayjs(fromDateUpdate), dayjs(toDateUpdate)]}
              onChange={handleDateChange}
            />
            <PageTitle
              useRefresh={true}
              setLoading={setLoading}
              onClickRefresh={() => {
                setTimeout(() => {
                  const newFromDate = dayjs()
                    .startOf("day")
                    .format("YYYY-MM-DD HH:mm");
                  const newToDate = dayjs()
                    .endOf("day")
                    .format("YYYY-MM-DD HH:mm");
                  setFromDateUpdate(newFromDate);
                  setToDateUpdate(newToDate);
                  setIsSelectingRange(false);
                  setTimePeriod("hour");
                  setPageIndex(0);
                  fetchSigninLogsStat();
                  fetchSigninLogs();
                  message.success(props.t("Data Refreshed Successfully"));
                }, 100);
              }}
            />
          </div>
        </div>
      </div>
      <div className="main-content-static">
        <div className="main-layout-content">
          <div className="layout-content-header">
            <div className="tittle-name-main">
              {props.t("LOGIN FREQUENCY BY TIME PERIOD")}
            </div>
            <div className="option-buttons">
              <button
                className={`t-btn btn-left-border 
                  ${
                    isSelectingRange
                      ? timePeriodUpdate === "hour"
                        ? "active"
                        : ""
                      : timePeriod === "hour"
                      ? "active"
                      : ""
                  }
                  `}
                onClick={() => onHandleTimePeriodChange("hour")}
              >
                {props.t("Hour")}
              </button>
              <button
                className={`t-btn 
                  ${
                    isSelectingRange
                      ? timePeriodUpdate === "day"
                        ? "active"
                        : ""
                      : timePeriod === "day"
                      ? "active"
                      : ""
                  }
                  `}
                onClick={() => onHandleTimePeriodChange("day")}
              >
                {props.t("Day")}
              </button>
              <button
                className={`t-btn btn-right-border 
                  ${
                    isSelectingRange
                      ? timePeriodUpdate === "month"
                        ? "active"
                        : ""
                      : timePeriod === "month"
                      ? "active"
                      : ""
                  }
                `}
                onClick={() => onHandleTimePeriodChange("month")}
              >
                {props.t("Month")}
              </button>
            </div>
          </div>
          <div className="static-chart">
            <Line data={chartData} options={options} height={450} width={600} />
          </div>
        </div>
      </div>
      <div className="footer-static-content">
        <div className="footer-tittle-container">
          <div className="tittle-name-container">
            <div className="tittle-name-ft">{props.t("LOGIN STATISTICS")}</div>
            <div className="tittle-input">
              <Input
                ref={searchInputRef}
                style={{
                  fontSize: "15px",
                  fontWeight: 400,
                  width: "300px",
                }}
                placeholder={props.t("Search by PID, FullName, PhoneNumber")}
                onPressEnter={onHandleSearchChange}
              />
            </div>
          </div>
          <div className="user-list-container">
            <ReactTableFixedColumns
              filterable
              loading={loading}
              loadingText={<Loader type="ball-pulse-rise" />}
              defaultFilterMethod={(filter, row) => {
                const id = filter.id;
                if (!row || !row[id]) return false;

                if (typeof filter.value === "object") {
                  return filter.value.indexOf(row[id]) > -1;
                } else {
                  return (
                    String(row[id])
                      .toUpperCase()
                      .indexOf(filter.value.toUpperCase()) > -1
                  );
                }
              }}
              columns={[
                {
                  filterable: false,
                  resizable: false,
                  sortable: false,
                  fixed: "left",
                  width: 50,
                  Header: `${props.t("No.")}`,
                  Cell: (state) => (
                    <div>
                      {state.page * state.pageSize + state.viewIndex + 1}
                    </div>
                  ),
                },
                {
                  Header: `${props.t("Username")}`,
                  filterable: true,
                  accessor: "userWebId",
                  width: 200,
                  Filter: ({ column }) => (
                    <Input
                      onPressEnter={(e) => {
                        const onChangeTableFilter = (id, value) => {
                          onFetchSigninLogSearch(value)
                        }
                        onChangeTableFilter(column.id, e.target.value)
                      }}
                    />
                  ),
                },
                {
                  Header: `${props.t("Login time")}`,
                  filterable: true,
                  accessor: "inTime",
                  width: 300,
                },
                {
                  Header: `${props.t("Full name")}`,
                  filterable: true,
                  accessor: "userName",
                  width: 300,
                },
                {
                  Header: `${props.t("Address")}`,
                  filterable: true,
                  accessor: "address",
                },
                {
                  Header: `${props.t("Gender")}`,
                  filterable: true,
                  accessor: "sex",
                  Cell: ({ value }) => {
                    return value === "F"
                      ? props.t("Female")
                      : value === "M"
                      ? props.t("Male")
                      : "";
                  },
                  width: 150,
                },
                {
                  Header: `${props.t("Phone number")}`,
                  filterable: true,
                  accessor: "phone",
                  width: 150,
                },
              ]}
              data={data}
              showPaginationBottom={true}
              rowsText={props.t("rows")}
              ofText={"/"}
              pageText={props.t("Page")}
              previousText={props.t("Previous page")}
              nextText={props.t("Next page")}
              noDataText={props.t("No data")}
              pageSizeOptions={pageSizeOptions}
              defaultPageSize={pageSize}
              pageSize={pageSize}
              page={pageIndex}
              manual
              pages={Math.floor(totalRecords / pageSize)}
              className="-striped -highlight -fixed"
              style={{ height: "calc(100vh - 155px)" }}
              PaginationComponent={Pagination}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              onFilteredChange={onHandleFilterChange}
            />
          </div>
        </div>
      </div>
    </div>
    )
  );
};
const mapStateToProps = (state) => ({
  global: state.global,
});
export default connect(mapStateToProps)(
  withTranslation(["dashboard"])(Dashboard)
);
